import { useState, useEffect } from 'react';

export type BreakpointName =
  | 'mobile'
  | 'tablet'
  | 'xs'
  | 'sm'
  | 'md'
  | 'lg'
  | 'xl';

interface Breakpoint {
  name: BreakpointName;
  width: number;
}

const breakpoints: Breakpoint[] = [
  { name: 'mobile', width: 375 },
  { name: 'tablet', width: 780 },
  { name: 'xs', width: 960 },
  { name: 'sm', width: 1024 },
  { name: 'md', width: 1280 },
  { name: 'lg', width: 1440 },
  { name: 'xl', width: 1600 },
];

const useBreakpoint = (): BreakpointName => {
  const [breakpoint, setBreakpoint] = useState<BreakpointName>('xl');

  useEffect(() => {
    const updateBreakpoint = (): void => {
      const width = window.innerWidth;

      const currentBreakpoint =
        breakpoints
          .slice()
          .reverse()
          .find((breakpoint) => width >= breakpoint.width)?.name || 'mobile';

      setBreakpoint(currentBreakpoint);
    };

    updateBreakpoint();
    window.addEventListener('resize', updateBreakpoint);

    return () => window.removeEventListener('resize', updateBreakpoint);
  }, []);

  return breakpoint;
};

export default useBreakpoint;
